// form
if(document.querySelector('.form-block')){
    let formBlock = document.querySelectorAll('.form-block');

        formBlock.forEach((el) => {
            let formBtn = el.querySelector('.btn'),
                textarea = el.querySelector('textarea'),
                success = el.querySelector('.success');

                formBtn.addEventListener('click', () => {
                    formBtn.style.display = 'none';
                    success.style.display = 'block';
                });
        });

        document.querySelectorAll('textarea').forEach(el => {
            el.style.height = el.setAttribute('style', 'height: ' + el.scrollHeight + 'px');
          
            el.addEventListener('input', e => {
                el.style.height = 'auto';
                el.style.height = (el.scrollHeight + 10) + 'px';

                if(!el.value){
                    el.style.height = 43 + 'px';
                }
            });
        });
}